import { gql } from '@apollo/client';

export const SEARCH_PHYSICIANS_QUERY = gql`
  query SearchPhysicians(
    $name: String = ""
    $firstName: String
    $lastName: String
    $state: String
    $city: String
    $zipCode: String
    $facilityName: String
    $credential: String
    $limit: Int = 10
  ) {
    searchPhysicians(
      name: $name
      firstName: $firstName
      lastName: $lastName
      state: $state
      city: $city
      zipCode: $zipCode
      facilityName: $facilityName
      credential: $credential
      limit: $limit
    ) {
      edges {
        physician {
          id
          npi
          lastName
          firstName
          middleName
          suffix
          credential
          primarySpecialty
          locations {
            id
            facilityName
            city
            state
            zipCode
          }
        }
        nameScore
        addressScore
        combinedScore
      }
      totalCount
    }
  }
`;

export const STUDY_SITE_INVESTIGATORS_QUERY = gql`
  query StudySiteInvestigators($studyId: UUID!, $siteOrganizationId: UUID) {
    studySiteInvestigators(studyId: $studyId, siteOrganizationId: $siteOrganizationId) {
      edges {
        id
        studyId
        siteOrganizationId
        physicianId
        status
        sourcePiName
        physician {
          id
          npi
          lastName
          firstName
          middleName
          suffix
          credential
          primarySpecialty
        }
        createdAt
      }
      totalCount
    }
  }
`;

export const GET_SSI_LIST_QUERY = gql`
  query GetSsiList($limit: Int = 100, $offset: Int = 0, $search: String) {
    studySiteInvestigatorsList(limit: $limit, offset: $offset, search: $search) {
      edges {
        id
        studyId
        siteOrganizationId
        physicianId
        status
        sourcePiName
        studyName
        studyProtocolId
        primaryProtocolAlias
        siteOrganizationName
        physician {
          id
          npi
          lastName
          firstName
          credential
          primarySpecialty
        }
        createdAt
      }
      totalCount
    }
  }
`;

export const GET_SSI_CONTEXT_QUERY = gql`
  query GetSsiContext($id: UUID!) {
    studySiteInvestigator(id: $id) {
      id
      studyId
      siteOrganizationId
      physicianId
      status
      sourcePiName
      studyName
      studyProtocolId
      primaryProtocolAlias
      siteOrganizationName
      sponsorName
      physician {
        id
        npi
        lastName
        firstName
        middleName
        suffix
        credential
        primarySpecialty
      }
      createdAt
    }
  }
`;
